/**
 * The original phrase-matching selector, kept as a planner.
 *
 * This is what shipped before the planner seam existed, unchanged in behaviour.
 * It stays for two reasons beyond history: it is the fallback whenever the
 * model-backed planner is disabled, unreachable or slow, and it is the reason
 * turning the model planner off is a safe operation rather than a regression.
 *
 * Its limits are the whole reason for the seam — see `types.ts` — so it is not
 * expected to grow. New skills should lean on the model planner for selection
 * and carry only enough synonyms to stay answerable when it is unavailable.
 */

import { resolveQuery } from '../knowledgeRegistry';
import type { AssistantAudience } from '../assistantCapabilities';
import type { AssistantPlanner, PlannerTool, QuestionPlan } from './types';

export const deterministicPlanner: AssistantPlanner = {
  plan: async (
    message: string,
    _tools: PlannerTool[],
    audience: AssistantAudience,
  ): Promise<QuestionPlan | null> => {
    const query = resolveQuery(message, audience);
    return query ? { queryId: query.id, source: 'deterministic' } : null;
  },
};

export default deterministicPlanner;
